export const coachWorld = {
  navbar: {
    solutions: "Miért CoachWorld?",
    features: "Funkciók",
    plusServices: "Plusz szolgáltatások",
    howItWorks: "Hogyan működik",
    pricing: "Árak",
    faq: "GYIK",
    about: "Rólunk",
    waitlistButton: "Ingyenes visszahívást kérek",
    subpages: {
      website: "Weboldal Építő",
      booking: "Foglalási Rendszer",
      marketing: "AI Marketing",
    },
  },
  seo: {
    title: "CoachWorld powered by Bespire - Platform coachoknak",
    description: "Építsd fel coaching vállalkozásod egy helyen: weboldal, foglalás, marketing, marketplace megjelenés és szakmai közösség.",
    keywords: "coach platform, coaching weboldal, coach marketplace, coaching foglalás, coach közösség",
  },
  hero: {
    badge: "CoachWorld powered by Bespire",
    title: "A coaching vállalkozásod megérdemli a legjobb eszközöket",
    subtitle: "Professzionális weboldal, intelligens foglalási rendszer, AI marketing és digitális termékértékesítés — egyetlen platformon, coachokra szabva.",
    description: "Csatlakozz a CoachWorld közösséghez és kapj marketplace megjelenést, szakmai eseményeket és dedikált növekedési támogatást.",
    cta: "Ingyenes visszahívást kérek",
    elviraBadge: "\"Végre egy platform, amit coachok coachoknak építettek.\" — Dobos Elvira",
    trustBadges: [
      "Magyar Coach Szövetség által ajánlott",
      "500+ coach használja",
      "85% időmegtakarítás",
    ],
    chatSimulation: {
      userMessage: "Coaching weboldalt szeretnék foglalási rendszerrel és online kurzusok értékesítésével",
      aiResponse: "Máris segítek! Létrehozok egy professzionális coaching weboldalt egyéni és csoportos session foglalással, online kurzus értékesítéssel és automatikus számlázással. Melyik coaching területen dolgozol?",
    },
  },
  ambassador: {
    badge: "Az oldal arca",
    name: "Dobos Elvira",
    title: "Okleveles üzleti coach, Certified Master Level",
    roles: [
      "Magyarországi Coach-szervezetek Szövetsége elnöke",
      "Magyar Coachszemle alapítója és főszerkesztője",
      "MyPro Solutions alapító társtulajdonos",
      "Okleveles mentálhigiénés szakember",
    ],
    quote: "A CoachWorld powered by Bespire olyan eszközt ad a coachok kezébe, amivel végre a szakmai munkájukra koncentrálhatnak, miközben az adminisztráció és az ügyfélszerzés automatikusan működik.",
    whySupports: "Miért áll mögötte a nevével?",
    whyDescription: "Elvira hisz abban, hogy a coaching szakma professzionalizálásához modern, digitális eszközökre van szükség. A CoachWorld pontosan ezt nyújtja: egy mindent-egyben platformot, ahol a coach a kliensre fókuszálhat.",
  },
  about: {
    seo: {
      title: "Rólunk — CoachWorld powered by Bespire",
      description: "Ismerd meg a CoachWorld mögött álló csapatot, küldetésünket és vízióinkat. Dobos Elvira, a Magyar Coach Szövetség elnöke által támogatott platform.",
    },
    heroTitle: "A CoachWorld küldetése",
    heroSubtitle: "Egy platform, amit coachok építettek coachoknak — hogy a coaching szakma végre megkapja a modern digitális eszközöket, amiket megérdemel.",
    mission: {
      title: "Küldetésünk",
      description: "A CoachWorld azért jött létre, hogy a coaching szakma professzionalizálását segítse. Hisszük, hogy minden coachnak jár egy professzionális online jelenlét, intelligens üzleti eszközök és egy támogató szakmai közösség — anélkül, hogy IT szakértővé kellene válnia.",
      points: [
        "Professzionális eszközök minden coachnak",
        "Közösség, ami támogat és fejleszt",
        "AI technológia, ami időt takarít meg",
        "Marketplace, ami összeköt coach és kliens között",
      ],
    },
    vision: {
      title: "Víziónk",
      description: "Olyan ökoszisztémát építünk, ahol a coaching szakma virágzik. Ahol a coach a kliensre fókuszál, az adminisztráció automatikus, és a szakmai fejlődés folyamatos. A CoachWorld nem csak szoftver — egy mozgalom a coaching szakma modernizálásáért.",
    },
    ambassador: {
      badge: "Az oldal arca",
      title: "Dobos Elvira",
      subtitle: "Okleveles üzleti coach, Certified Master Level",
      bio: "Dobos Elvira a Magyarországi Coach-szervezetek Szövetségének elnöke, a Magyar Coachszemle alapítója és főszerkesztője, a MyPro Solutions alapító társtulajdonosa, valamint okleveles mentálhigiénés szakember. Több mint 15 éves tapasztalatával a coaching szakma egyik legmeghatározóbb alakja Magyarországon.",
      roles: [
        "Magyarországi Coach-szervezetek Szövetsége elnöke",
        "Magyar Coachszemle alapítója és főszerkesztője",
        "MyPro Solutions alapító társtulajdonos",
        "Okleveles mentálhigiénés szakember",
      ],
      quote: "A CoachWorld powered by Bespire olyan eszközt ad a coachok kezébe, amivel végre a szakmai munkájukra koncentrálhatnak, miközben az adminisztráció és az ügyfélszerzés automatikusan működik.",
      whyTitle: "Miért áll mögötte a nevével?",
      whyDescription: "Elvira hisz abban, hogy a coaching szakma professzionalizálásához modern, digitális eszközökre van szükség. A CoachWorld pontosan ezt nyújtja: egy mindent-egyben platformot, ahol a coach a kliensre fókuszálhat. Évtizedes tapasztalata és a szakma iránti elkötelezettsége garantálja, hogy a platform valóban a coachok igényeit szolgálja.",
    },
    bespire: {
      title: "A Bespire technológia",
      description: "A CoachWorld a Bespire platform coach-specifikus verziója. A Bespire egy magyar fejlesztésű, AI-vezérelt üzleti platform, amely weboldalépítést, foglalási rendszert, digitális termékértékesítést és marketing automatizálást kínál. A CoachWorld ezt a robusztus technológiai alapot egészíti ki coach-specifikus funkciókkal: marketplace, szakmai közösség, események és személyre szabott növekedési támogatás.",
    },
    cta: {
      title: "Csatlakozz a CoachWorld közösséghez",
      subtitle: "Kérj ingyenes visszahívást és tudd meg, hogyan segíthetünk coaching vállalkozásod fejlesztésében.",
      button: "Ingyenes visszahívást kérek",
    },
  },
  marketplace: {
    badge: "CoachHub Marketplace",
    title: "Ahol a kliensek megtalálnak téged",
    subtitle: "A CoachHub Marketplace egy dedikált piactér, ahol potenciális kliensek kereshetnek, szűrhetnek és választhatnak a CoachWorld coachok közül.",
    howItWorks: {
      title: "Hogyan működik?",
      steps: [
        {
          title: "Profilod automatikusan elkészül",
          description: "A CoachWorld tagságod aktiválásakor a weboldalad és szolgáltatásaid alapján automatikusan létrejön a marketplace profilod.",
        },
        {
          title: "Kliensek rátalálnak",
          description: "Potenciális kliensek szakterület, helyszín, ár, értékelés és elérhetőség alapján szűrhetnek és kereshetnek coachot.",
        },
        {
          title: "Közvetlen foglalás",
          description: "A kliensek a marketplace-ről közvetlenül foglalhatnak nálad — nem kell semmit tenned, az érdeklődők maguktól jönnek.",
        },
      ],
    },
    benefits: [
      "Havi 8-12 új érdeklődő átlagosan",
      "SEO-optimalizált coach profil",
      "Értékelések és referenciák megjelenítése",
      "Kiemelt pozíció a Pro csomagban",
    ],
    mockup: {
      searchPlaceholder: "Keresés: business coach Budapest...",
      filterSpecialty: "Szakterület",
      filterLocation: "Helyszín",
      filterPrice: "Árkategória",
      resultsTitle: "Találatok",
      profileBadge: "CoachWorld tag",
      bookButton: "Foglalás",
      ratingLabel: "értékelés",
    },
  },
  impact: {
    title: "Számok, amik beszélnek",
    subtitle: "Coachok, akik a CoachWorld-öt használják, átlagosan ezeket az eredményeket érik el",
    stats: [
      { value: "500+", label: "Coach a platformon" },
      { value: "10 000+", label: "Lefoglalt session havonta" },
      { value: "85%", label: "Időmegtakarítás adminisztrációban" },
      { value: "3x", label: "Több online megkeresés átlagosan" },
      { value: "40%", label: "Bevételnövekedés az első 6 hónapban" },
      { value: "24/7", label: "Az AI asszisztens mindig elérhető" },
    ],
  },
  solutions: {
    title: "Minden eszköz, amit coaching vállalkozásodhoz szükséged van",
    subtitle: "A Bespire teljes szoftvere coachokra szabva — részletesen bemutatva",
    items: [
      {
        title: "Professzionális coaching weboldal",
        description: "Az AI asszisztens segít felépíteni a teljes coaching weboldaladat: bemutatkozás, módszertan, referenciák, szolgáltatások. Nem kell programozó, nem kell designer — beszélgetsz az AI-al, és kész az oldalad.",
        features: [
          "Coaching módszertan és filozófia oldal",
          "Referenciák és ügyfélvélemények",
          "Szolgáltatás portfólió részletes leírásokkal",
          "SEO optimalizált tartalom automatikusan",
          "Saját domain és brand arculat",
          "Mobilra optimalizált megjelenés",
        ],
        detailsButton: "Weboldal Építő részletei",
        chat: {
          title: "Bespire AI Asszisztens",
          online: "Online",
          messages: [
            { role: "user" as const, content: "Coaching weboldalt szeretnék, ahol bemutathatom a módszertanomat és az ügyfeleimnek foglalási lehetőséget adok." },
            { role: "assistant" as const, content: "Remek! Készítek egy professzionális coaching weboldalt. Milyen coaching területen dolgozol?", list: ["Bemutatkozó oldal módszertannal", "Szolgáltatások részletezve", "Foglalási rendszer integrálva", "Ügyfélvélemények szekció"] },
            { role: "user" as const, content: "Business coaching, főleg vezetőknek és csapatoknak." },
            { role: "assistant" as const, content: "Tökéletes! Elkészítettem az executive coaching weboldaladat modern, professzionális dizájnnal. Nézd meg az előnézetet!" },
          ],
        },
      },
      {
        title: "Intelligens foglalási rendszer",
        description: "Egyéni és csoportos sessionök, automatikus emlékeztetők, naptár szinkron, bérletek, fizetés kezelés — minden, ami egy coaching gyakorlathoz kell.",
        features: [
          "Egyéni coaching sessionök online foglalása",
          "Csoportos workshopok és programok",
          "Automatikus e-mail és SMS emlékeztetők",
          "Google Calendar és Outlook szinkron",
          "Bérlet- és csomagkezelés",
          "Online és személyes sessionök kezelése",
        ],
        detailsButton: "Foglalási Rendszer részletei",
        chat: {
          title: "Bespire AI Asszisztens",
          online: "Online",
          messages: [
            { role: "user" as const, content: "Szeretném, ha az ügyfeleim maguk tudnának időpontot foglalni." },
            { role: "assistant" as const, content: "Beállítom a foglalási rendszered! Milyen típusú sessionöket tartasz?" },
            { role: "user" as const, content: "Egyéni coachingot 60 percben és csoportos workshopokat 3 órában." },
            { role: "assistant" as const, content: "Kész! Az ügyfeleid most már foglalhatnak:", list: ["60 perces egyéni session — 25 000 Ft", "3 órás csoportos workshop — 15 000 Ft/fő", "Automatikus emlékeztető 24 órával előtte", "Google Calendar szinkronizálva"] },
          ],
        },
      },
      {
        title: "Digitális termékek értékesítése",
        description: "Értékesíts online kurzusokat, e-könyveket, coaching sablonokat, workbookokat. Automatikus hozzáférés a fizetés után, integrált számlázás.",
        features: [
          "Online kurzusok és képzések",
          "E-könyvek és coaching workbookok",
          "Letölthető sablonok és eszközök",
          "Automatikus hozzáférés fizetés után",
          "Integrált fizetés és számlázás",
          "Kupon és akciókód kezelés",
        ],
        detailsButton: "Marketing részletei",
        chat: {
          title: "Bespire AI Asszisztens",
          online: "Online",
          messages: [
            { role: "user" as const, content: "Van egy coaching workbookom, amit szeretnék online értékesíteni." },
            { role: "assistant" as const, content: "Szuper! Feltöltöm a digitális termékek közé. Mi legyen az ára és a leírása?" },
            { role: "user" as const, content: "Vezetoi onismeret workbook - 4 990 Ft, PDF formatum." },
            { role: "assistant" as const, content: "Kész! A workbook elérhető a weboldaladon:", list: ["Automatikus PDF letöltés fizetés után", "Számlázás automatikusan", "Termékoldalon SEO optimalizálva", "Promóciós kuponkód létrehozva: COACH20"] },
          ],
        },
      },
      {
        title: "AI marketing és tartalomkészítés",
        description: "Az AI generálja a social media posztjaidat, blog cikkeidet, newsletter-eidet. Az AI ismeri a coaching szakterületed és a hangnemed.",
        features: [
          "Social media poszt generálás coaching témákban",
          "Blog és szakmai cikk írás AI-al",
          "E-mail marketing és newsletter",
          "Hashtag és SEO javaslatok",
          "Instagram, Facebook, LinkedIn integráció",
          "Tartalomnaptár és ütemezés",
        ],
        detailsButton: "Marketing részletei",
        chat: {
          title: "Bespire AI Asszisztens",
          online: "Online",
          messages: [
            { role: "user" as const, content: "Írj nekem egy LinkedIn posztot a vezetői burnout megelőzéséről." },
            { role: "assistant" as const, content: "Írtam egy szakmai LinkedIn posztot a profilodhoz illeszkedő stílusban:", list: ["🔥 Felismered a jeleket? — 5 korai figyelmeztető jel...", "Professzionális, hiteles hangnem", "Releváns hashtagek generálva", "Egy kattintással publikálható"] },
            { role: "user" as const, content: "Ez nagyon jó! Készíts belőle egy newsletter-t is." },
            { role: "assistant" as const, content: "A newsletter elkészült és ütemezve van holnap reggel 8:00-ra. 347 feliratkozódnak megy ki." },
          ],
        },
      },
    ],
  },
  howItWorks: {
    title: "Hogyan kezdj bele?",
    subtitle: "Két út áll előtted — válaszd azt, amelyik neked kényelmes",
    pathA: {
      tab: "Csináld magad, AI segítséggel",
      steps: [
        { title: "Vedd fel velünk a kapcsolatot", description: "Kérj ingyenes visszahívást, és megkapod a hozzáférést a rendszerhez." },
        { title: "Építsd fel az oldalad", description: "Az AI asszisztens segít összerakni a coaching weboldaladat, a szolgáltatásaidat és a foglalási rendszered." },
        { title: "Indulj el és növekedj", description: "Publikáld az oldaladat, fogadj foglalásokat, és használd az AI marketing eszközöket az ügyfélszerzéshez." },
      ],
    },
    pathB: {
      tab: "Mi megcsináljuk helyetted",
      title: "Nincs semmi időd?",
      description: "Felépítjük a teljes coaching rendszered, neked csak használnod kell. Egyszeri díj: 50.000 Ft + ÁFA.",
      steps: [
        { title: "Egyeztetés", description: "Megbeszéljük, milyen coaching szolgáltatásokat nyújtasz és milyen oldalt szeretnél." },
        { title: "Felépítjük a rendszered", description: "Elkészítjük a weboldaladat, beállítjuk a foglalási rendszert, feltöltjük a szolgáltatásaidat." },
        { title: "Átadás és oktatás", description: "Megmutatjuk, hogyan használd a rendszert és az AI asszisztenst a napi működéshez." },
      ],
      cta: "Ingyenes visszahívást kérek",
    },
  },
  plusServices: {
    badge: "Exkluzív előnyök",
    title: "Exkluzív előnyök CoachWorld tagoknak",
    subtitle: "Ezeket a szolgáltatásokat kizárólag a CoachWorld tagok kapják a teljes Bespire platformon felül",
    items: [
      {
        title: "CoachHub Marketplace megjelenés",
        description: "Profild megjelenik a CoachHub marketplace-en, ahol kliensek kereshetnek, szűrhetnek és válogathatnak coachok közül. Szakterület, helyszín, ár és értékelés alapján találnak rád.",
        example: "Egy life coach havi 8-12 új érdeklődőt kap a marketplace-ről, akik célzottan keresnek coaching szolgáltatást.",
        icon: "Store",
      },
      {
        title: "Szakmai közösség",
        description: "Zárt coach közösség, ahol tapasztalatot cserélhetsz, kérdéseket tehetsz fel és együttműködhetsz más coachokkal. Heti peer coaching csoportok, ahol más coachokkal dolgozhatsz a saját eseteiden.",
        example: "Heti rendszerességgel peer coaching csoportok, ahol más coachokkal dolgozhatsz a saját eseteiden.",
        icon: "Users",
      },
      {
        title: "Havi szakmai események",
        description: "Online workshopok, mesterkurzusok, vendég előadók — üzleti, pszichológiai és marketing témákban. Minden esemény visszanézhető felvételről is.",
        example: "Legutóbbi téma: \"Hogyan építsd fel 6 jegyű coaching vállalkozásod online?\" — 120+ résztvevővel.",
        icon: "Calendar",
      },
      {
        title: "Dedikált növekedési tanácsadó",
        description: "Nem egy helpdesk, hanem egy személyes kapcsolattartó, aki proaktívan segít az oldalad és vállalkozásod optimalizálásában. Havi 1 személyes konzultáció.",
        example: "Havi 1 személyes konzultáció, ahol átnézzük a statisztikáidat és javaslatokat kapsz a fejlődéshez.",
        icon: "Headphones",
      },
      {
        title: "Ügyfélszerzési stratégiák és tananyagok",
        description: "Havi marketing tananyag kifejezetten coachoknak: hogyan szerezz több klienst online, milyen tartalom működik, hogyan pozícionáld magad. Kész sablonok és bevált funnelek.",
        example: "Kész tartalomsablonok, email sorozat minták, és bevált ügyfélszerzési funnelok — azonnal használható formában.",
        icon: "TrendingUp",
      },
    ],
  },
  comparison: {
    title: "Miért CoachWorld és nem sima Bespire?",
    subtitle: "A CoachWorld csomag mindent tartalmaz, amit a Bespire platform nyújt — és még sokkal többet",
    headers: ["Funkció", "Bespire", "CoachWorld"],
    features: [
      { name: "Professzionális weboldal", bespire: true, coachWorld: true },
      { name: "Foglalási rendszer", bespire: true, coachWorld: true },
      { name: "Digitális termék értékesítés", bespire: true, coachWorld: true },
      { name: "AI marketing eszközök", bespire: true, coachWorld: true },
      { name: "Automatikus számlázás", bespire: true, coachWorld: true },
      { name: "Coach marketplace megjelenés", bespire: false, coachWorld: true },
      { name: "Szakmai coach közösség", bespire: false, coachWorld: true },
      { name: "Havi szakmai események", bespire: false, coachWorld: true },
      { name: "Dedikált növekedési tanácsadó", bespire: false, coachWorld: true },
      { name: "Ügyfélszerzési tananyagok", bespire: false, coachWorld: true },
      { name: "Coach-specifikus sablonok", bespire: false, coachWorld: true },
    ],
  },
  successStories: {
    title: "Coachok, akik már a CoachWorld-öt használják",
    subtitle: "Valós eredmények valós coachoktól",
    stories: [
      {
        name: "Szilágyi Réka",
        type: "Executive Coach",
        quote: "A CoachWorld-nek köszönhetően a foglalásom 70%-a automatikusan jön — végre a coaching munkára koncentrálhatok.",
        stats: [
          { value: "70%", label: "Automatikus foglalás" },
          { value: "3x", label: "Több kliens" },
        ],
      },
      {
        name: "Tóth Péter",
        type: "Business Coach",
        quote: "Az online kurzusom az első hónapban 40 eladást hozott. A marketplace megjelenés aranyat ér.",
        stats: [
          { value: "40", label: "Kurzus eladás/hó" },
          { value: "+380k Ft", label: "Extra bevétel" },
        ],
      },
      {
        name: "Kovács Ildikó",
        type: "Life Coach",
        quote: "A szakmai közösség a legjobb befektetés. Hetente tanulok valamit, amit azonnal alkalmazok a gyakorlatban.",
        stats: [
          { value: "12", label: "Új kliens/hó" },
          { value: "4.9★", label: "Átlagos értékelés" },
        ],
      },
    ],
  },
  featureBento: {
    title: "Minden, amit a CoachWorld csomagban kapsz",
    subtitle: "Egy áttekintés az összes funkcióról",
    platformLabel: "Platform funkciók",
    extraLabel: "CoachWorld extrák",
    features: [
      { title: "AI weboldal építő", description: "Beszélgetsz az AI-al, és felépíti a teljes coaching weboldaladat — bemutatkozás, szolgáltatások, referenciák", icon: "Globe" },
      { title: "Foglalási rendszer", description: "Egyéni és csoportos session foglalás", icon: "CalendarCheck" },
      { title: "Digitális termékek", description: "Kurzusok, e-könyvek, workbookok", icon: "ShoppingBag" },
      { title: "AI marketing", description: "Posztok, blog cikkek, newsletter generálás — a te hangodban, a te témáidban, automatikusan", icon: "Megaphone" },
      { title: "Marketplace", description: "Kliensek találnak rád a marketplace-en", icon: "Store" },
      { title: "Számlázás", description: "Automatikus számla minden tranzakcióra", icon: "Receipt" },
      { title: "Ügyfélkezelés", description: "CRM, címkék, szegmentálás", icon: "Users" },
      { title: "Naptár szinkron", description: "Google Calendar, Outlook integráció", icon: "Calendar" },
      { title: "Emlékeztetők", description: "Automatikus e-mail és SMS értesítések — az ügyfeleid sosem felejtik el a sessiont", icon: "Bell" },
      { title: "Szakmai közösség", description: "Zárt coach networking platform", icon: "Heart" },
      { title: "Havi események", description: "Workshopok, mesterkurzusok, előadók", icon: "Video" },
      { title: "Analitika", description: "Részletes statisztikák és riportok", icon: "BarChart" },
    ],
  },
  pricing: {
    title: "Válaszd ki a CoachWorld csomagodat",
    subtitle: "Exkluzív árazás — csak itt érhető el, a hagyományos Bespire csomagtól eltérő, teljes körű coaching csomag",
    plans: {
      alap: {
        badge: "CoachWorld Alap",
        name: "CoachWorld Alap",
        price: "25 000",
        currency: "Ft",
        period: "/ hó + ÁFA",
        description: "A teljes Bespire platform + CoachWorld alap szolgáltatások",
        features: [
          "Professzionális coaching weboldal",
          "Foglalási rendszer (egyéni + csoportos)",
          "Digitális termék értékesítés",
          "AI marketing eszközök (10 kredit/hó)",
          "Automatikus számlázás",
          "Ügyfélkezelés és CRM",
          "Marketplace megjelenés",
          "Szakmai közösség hozzáférés",
          "Havi online események",
        ],
        cta: "Ingyenes visszahívást kérek",
      },
      pro: {
        badge: "CoachWorld Pro",
        name: "CoachWorld Pro",
        price: "45 000",
        currency: "Ft",
        period: "/ hó + ÁFA",
        popular: "Legnépszerűbb",
        description: "Minden az Alap csomagból + prémium szolgáltatások a maximális növekedéshez",
        features: [
          "Minden az Alap csomagból",
          "AI-asszisztens a napi munkádhoz",
          "Kiemelt marketplace pozíció",
          "Dedikált növekedési tanácsadó",
          "Havi 1:1 stratégiai konzultáció",
          "Prémium ügyfélszerzési tananyagok",
          "Prioritásos technikai support",
          "Haladó analitika és riportok",
          "Saját domain beállítás",
        ],
        cta: "Ingyenes visszahívást kérek",
      },
    },
    setup: {
      title: "Teljes körű beüzemelés",
      price: "50 000",
      currency: "Ft",
      suffix: "+ ÁFA (egyszeri)",
      description: "Nem akarsz vele bajlódni? Felépítjük a teljes rendszered, neked csak használnod kell.",
      features: [
        "Weboldal felépítése a tartalmaiddal",
        "Szolgáltatások és árak feltöltése",
        "Foglalási rendszer beállítása",
        "E-mail marketing konfiguráció",
        "SEO alap beállítások",
        "Személyes platform oktatás (60 perc)",
      ],
    },
    cta: "Ingyenes visszahívást kérek",
    guarantee: [
      "Nincs rejtett költség",
      "Bármikor lemondható",
      "48 órán belüli válasz",
      "Elégedettségi garancia",
    ],
  },
  faq: {
    title: "Gyakran Ismételt Kérdések",
    subtitle: "Minden, amit a CoachWorld-ről tudnod kell",
    items: [
      { question: "Kinek szól a CoachWorld?", answer: "Minden coachnak, aki professzionálisan szeretné építeni online jelenlétét: life coachok, business coachok, executive coachok, team coachok, career coachok és coaching tanácsadók." },
      { question: "Mi a különbség a CoachWorld Alap és a Pro csomag között?", answer: "Az Alap csomag tartalmazza a teljes platformot és a közösségi funkciókat. A Pro csomagban ezen felül kapsz dedikált növekedési tanácsadót, havi stratégiai konzultációt, kiemelt marketplace pozíciót, AI-asszisztenst a napi munkádhoz és prémium tananyagokat." },
      { question: "Ez ugyanaz, mint a sima Bespire előfizetés?", answer: "Nem. A CoachWorld egy önálló, exkluzív csomag, ami tartalmazza a Bespire teljes platformját, de coach-specifikus extrákkal: marketplace, közösség, események, tanácsadás. Ez az ár csak itt érhető el." },
      { question: "Hogyan jelenik meg a profilom a marketplace-en?", answer: "A CoachWorld tagság aktiválása után automatikusan létrehozzuk a marketplace profilodat a weboldalad adatai alapján. Kliensek szűrhetnek szakterület, helyszín, ár és értékelések alapján." },
      { question: "Milyen események vannak havonta?", answer: "Havi 2-4 online esemény: szakmai workshopok, mesterkurzusok business és marketing témákban, vendég előadók, és networking alkalmak. Minden esemény visszanézhető felvételről is." },
      { question: "Mi az egyszeri beüzemelési díj?", answer: "50.000 Ft + ÁFA egyszeri díj, amiért mi felépítjük a teljes rendszered: weboldal, foglalási rendszer, szolgáltatások feltöltése és személyes oktatás." },
      { question: "Kipróbálhatom mielőtt fizetek?", answer: "Kérj ingyenes visszahívást, és részletesen bemutatjuk a platformot. Megválaszolunk minden kérdést, mielőtt bármit is döntenél." },
      { question: "Bármikor lemondhatom?", answer: "Igen, nincs elköteleződés. A havi tagságot bármikor lemondhatod, az adataid megmaradnak." },
    ],
  },
  newsletter: {
    title: "Kérj ingyenes visszahívást",
    subtitle: "Add meg telefonszámod és 48 órán belüli visszahívunk — teljesen ingyen, kötelezettség nélkül.",
    namePlaceholder: "Neved (pl. Kovács Anna)",
    phonePlaceholder: "Telefonszámod (pl. +36 30 123 4567)",
    professionLabel: "Foglalkozásod",
    professionDefault: "Coach",
    setupOption: {
      label: "Szeretnéd, hogy teljesen beüzemeljük az oldalad?",
      yes: "Igen, kérem a teljes beüzemelést (50.000 Ft + ÁFA, egyszeri díj)",
      no: "Nem, magam szeretném kezelni",
    },
    websiteStatus: {
      label: "Van már weboldalad?",
      hasWebsite: "Igen, van weboldalam",
      noWebsite: "Nem, most indulok",
      websitePlaceholder: "Add meg a weboldalad címét (pl. www.example.hu)",
    },
    submitButton: "Ingyenes visszahívást kérek",
    privacyNote: "Az adataidat bizalmasan kezeljük. A visszahívás teljesen ingyenes.",
    callbackNote: "48 órán belüli visszahívás munkanapokon.",
    freeBadge: "100% ingyenes",
  },
  footer: {
    tagline: "A coaching vállalkozásod megérdemli a legjobb digitális eszközöket.",
    platformTitle: "Platform",
    platformLinks: [
      { label: "Professzionális weboldal", path: "/coachworld/website" },
      { label: "Foglalási rendszer", path: "/coachworld/booking" },
      { label: "Marketing eszközök", path: "/coachworld/marketing" },
      { label: "Rólunk", path: "/coachworld/about" },
    ],
    sectionsTitle: "Felfedezés",
    sectionLinks: [
      { label: "Miért CoachWorld?", id: "solutions" },
      { label: "Hogyan működik", id: "how-it-works" },
      { label: "Árak", id: "pricing" },
      { label: "GYIK", id: "faq" },
    ],
    contactTitle: "Kapcsolat",
    contactDescription: "Kérdésed van? Kérj ingyenes visszahívást és segítünk elindulni.",
    ctaButton: "Visszahívást kérek",
    copyright: "© 2025 CoachWorld powered by Bespire. Minden jog fenntartva.",
    bespireNote: "A Bespire technológiával működik.",
  },
  websitePage: {
    seo: {
      title: "Coaching Weboldal Építő — CoachWorld powered by Bespire",
      description: "Építs professzionális coaching weboldalt AI segítséggel. Bemutatkozás, módszertan, referenciák, foglalás — percek alatt.",
    },
    hero: {
      title: "Coaching weboldal, ami ügyfeleket szerez",
      subtitle: "Az AI asszisztens segít felépíteni a teljes weboldaladat — nem kell programozó, nem kell designer. Beszélgetsz, és kész.",
      cta: "Ingyenes visszahívást kérek",
    },
    features: {
      title: "Minden funkció, ami egy coaching weboldalhoz kell",
      subtitle: "Részletesen bemutatjuk a legfontosabb weboldal-építő funkciókat",
      highlights: [
        {
          title: "AI tartalomírás, ami ismeri a szakmád",
          description: "Az AI nem generikus szöveget ír — megismeri a coaching módszertanodat, a célközönséged és a hangnemed. Minden bemutatkozás, szolgáltatás leírás és blog cikk hiteles és személyes lesz.",
          icon: "Sparkles",
          points: [
            "Bemutatkozás a te stílusodban, percek alatt",
            "Szolgáltatás oldalak részletes leírásokkal",
            "Blog cikkek, amik SEO értéket is teremtenek",
            "Többnyelvű tartalom generálás",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "Drag & drop, ami tényleg egyszerű",
          description: "Nem kell kódolnod, nem kell dizájnernek lenned. Húzd-ejtsd szerkesztővel rendezd el a szekciók sorrendjét, válassz előre elkészített blokkokat és szabd testre a színeket.",
          icon: "Layout",
          points: [
            "Előre elkészített szekció blokkok",
            "Színek és betűtípusok testreszabása",
            "Képgaléria és videó beágyazás",
            "Élő előnézet szerkesztés közben",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "SEO, ami automatikusan dolgozik",
          description: "Nem kell SEO szakértőnek lenned. A rendszer automatikusan optimalizálja a meta címeket, leírásokat, képek alt szövegeit és az oldal sebességét.",
          icon: "Search",
          points: [
            "Automatikus meta cím és leírás",
            "Képek optimalizálása és alt szövegek",
            "Oldal sebesség optimalizálás",
            "Google Search Console integráció",
          ],
          mockupLines: ["", "", "", "", ""],
        },
      ],
      items: [
        { title: "AI tartalomírás", description: "Az AI megírja a bemutatkozásodat, szolgáltatásaid leírását, blog cikkeidet — a te hangodban.", icon: "Sparkles" },
        { title: "Drag & drop szerkesztés", description: "Húzd-ejtsd szerkesztő, amellyel bármit elrendezhetsz — kód nélkül.", icon: "Layout" },
        { title: "Coaching sablonok", description: "Előre elkészített, coach-specifikus oldalsablonok.", icon: "FileText" },
        { title: "Saját domain", description: "Használd a saját domain neved professzionális megjelenéshez.", icon: "Globe" },
        { title: "Mobilra optimalizált", description: "Minden oldal automatikusan tökéletesen néz ki telefonon és tableten.", icon: "Smartphone" },
        { title: "SEO beépítve", description: "Automatikus SEO optimalizálás, hogy a Google-ben is megtaláljanak.", icon: "Search" },
        { title: "Szolgáltatás portfólió", description: "Részletes szolgáltatás oldalak árlistával és foglalási gombbal.", icon: "Briefcase" },
        { title: "Ügyfélvélemények", description: "Mutasd be a referenciáidat és az ügyfeleid visszajelzéseit.", icon: "Star" },
        { title: "Blog és tartalom", description: "Publikálj szakmai cikkeket, amik pozícionálnak.", icon: "BookOpen" },
      ],
    },
    deepDive: {
      title: "Hogyan épül fel a coaching weboldalad?",
      sections: [
        {
          title: "1. Beszélgetsz az AI-al a célokról",
          description: "Az AI asszisztens megkérdezi, milyen coaching területen dolgozol, kik a célcsoportjaid, milyen szolgáltatásokat kínálsz. Ez alapján elkészíti a teljes weboldal struktúráját és tartalmát.",
          visual: "chat",
        },
        {
          title: "2. Válaszd ki a megjelenést",
          description: "Válassz az előre elkészített coaching sablonok közül, vagy szabd testre a színeket, betűtípusokat és elrendezést. Minden sablon mobilra optimalizált és professzionális.",
          visual: "template",
        },
        {
          title: "3. Publikáld és indulj",
          description: "Egy kattintással publikáld a weboldalad saját domain néven. Az AI folyamatosan segít a tartalom frissítésében, SEO optimalizálásban és blog cikkek írásában.",
          visual: "publish",
        },
      ],
    },
    useCases: {
      title: "Coaching weboldal típusok",
      items: [
        {
          title: "Executive coaching",
          description: "Professzionális, céges megjelenés vezetői coaching szolgáltatásokhoz. Referenciák, módszertan, céges ajánlatkérés lehetőség.",
        },
        {
          title: "Life coaching",
          description: "Meleg, személyes hangvételű oldal egyéni fejlődési programokkal, online foglalással és blog szekcióval.",
        },
        {
          title: "Team coaching",
          description: "Csapat-coaching és workshop portfólió, csoportos foglalási lehetőségek, céges bemutatkozó anyagok.",
        },
      ],
    },
    stats: [
      { value: "30 perc", label: "Átlagos weboldalépítési idő" },
      { value: "98%", label: "Mobilra optimalizált oldalak" },
      { value: "3x", label: "Több Google megjelenés" },
      { value: "0 Ft", label: "Extra fejlesztési költség" },
    ],
    faq: {
      title: "Weboldal Építő — Gyakori Kérdések",
      items: [
        { question: "Tényleg 30 perc alatt kész az oldalam?", answer: "Igen! Az AI asszisztens segít felépíteni a teljes weboldaladat. Csak a tartalmi kérdésekre kell válaszolnod, az AI elkészíti az oldalakat." },
        { question: "Használhatom a saját domainem?", answer: "Igen, bármilyen saját domain nevet csatlakoztathatsz a coaching weboldaladhoz. Mi segítünk a beállításban." },
        { question: "Mi van, ha nem tudok jól szöveget írni?", answer: "Az AI asszisztens generálja a tartalmat helyetted. Csak a coaching területedet és a célközönséged kell megadnod, a többit megírja." },
        { question: "Le tudom cserélni a design-t később?", answer: "Igen, bármikor módosíthatod a színeket, elrendezést, képeket. Az adataid megmaradnak." },
        { question: "Hány oldalt hozhatok létre?", answer: "Korlátlan számú oldalt hozhatsz létre: bemutatkozás, szolgáltatások, blog, referenciák, kapcsolat — mindent, ami kell." },
        { question: "Van e-commerce funkció is?", answer: "Igen! Digitális termékeket (e-könyvek, kurzusok, workbookok) közvetlenül a weboldaladról értékesítheted, automatikus fizetéssel és hozzáféréssel." },
      ],
    },
    cta: {
      title: "Készen állsz a coaching weboldaladra?",
      subtitle: "Kérj ingyenes visszahívást, és megmutatjuk, hogyan épül fel a weboldalad 30 perc alatt.",
      button: "Ingyenes visszahívást kérek",
    },
  },
  bookingPage: {
    seo: {
      title: "Coaching Foglalási Rendszer — CoachWorld powered by Bespire",
      description: "Intelligens foglalási rendszer coachoknak: egyéni sessionök, csoportos workshopok, bérletek, automatikus emlékeztetők.",
    },
    hero: {
      title: "Foglalási rendszer, ami dolgozik helyetted",
      subtitle: "Ügyfeleid bármikor foglalhatnak — te csak a coachingra koncentrálsz. Egyéni és csoportos sessionök, bérletek, fizetés, emlékeztetők — minden automatikusan.",
      cta: "Ingyenes visszahívást kérek",
    },
    features: {
      title: "Minden, ami egy coaching foglalási rendszerhez kell",
      subtitle: "Részletesen bemutatjuk a legfontosabb foglalási funkciókat",
      highlights: [
        {
          title: "Egyéni és csoportos sessionök",
          description: "Az ügyfeleid kiválasztják a session típusát, az időpontot, és online fizetnek. Te csak a coachingra koncentrálsz. Csoportos workshopok létszámkorláttal és automatikus regisztrációval.",
          icon: "User",
          points: [
            "Különböző session típusok és időtartamok",
            "Online és személyes sessionök kezelése",
            "Csoportos workshopok létszámkorláttal",
            "Automatikus visszaigazolás e-mailben",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "Bérlet- és csomagkezelés",
          description: "Készíts 5, 10, 20 alkalmas bérleteket, amik automatikusan kezelik az alkalmak számát. Az ügyfél egyszerűen lefoglal egy alkalmat a bérletéből, a rendszer levon egyet.",
          icon: "CreditCard",
          points: [
            "Tetszőleges alkalomszámú bérletek",
            "Automatikus alkalom-nyilvántartás",
            "Lejárati dátum és figyelmeztetés",
            "Bérlet megújítás egy kattintással",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "Naptár szinkron és emlékeztetők",
          description: "A foglalások automatikusan megjelennek a Google Calendar-odban vagy Outlook-odban. Az ügyfeleid automatikus emlékeztetőket kapnak e-mailben és SMS-ben.",
          icon: "Calendar",
          points: [
            "Google Calendar és Outlook szinkron",
            "E-mail emlékeztető 24 órával előtte",
            "SMS emlékeztető 1 órával előtte",
            "Dupla foglalás elleni védelem",
          ],
          mockupLines: ["", "", "", "", ""],
        },
      ],
      items: [
        { title: "Egyéni sessionök", description: "Ügyfeleid kiválasztják az időpontot, a session típusát és online fizetnek.", icon: "User" },
        { title: "Csoportos workshopok", description: "Hirdess csoportos programokat létszámkorláttal és automatikus regisztrációval.", icon: "Users" },
        { title: "Bérlet kezelés", description: "Készíts 5, 10, 20 alkalmas bérleteket.", icon: "CreditCard" },
        { title: "Naptár szinkron", description: "Google Calendar és Outlook szinkron.", icon: "Calendar" },
        { title: "Automatikus emlékeztetők", description: "E-mail és SMS emlékeztetők a session előtt.", icon: "Bell" },
        { title: "Online és személyes", description: "Zoom/Google Meet link automatikusan.", icon: "Video" },
        { title: "Fizetés kezelés", description: "Online fizetés bankkártyával, automatikus számlázás.", icon: "Wallet" },
        { title: "Visszamondás kezelés", description: "Beállítható visszamondási feltételek.", icon: "RefreshCw" },
        { title: "Várólisták", description: "Ha egy időpont betelt, az érdeklődők várólistára kerülhetnek.", icon: "Clock" },
      ],
    },
    deepDive: {
      title: "Így működik a foglalási rendszer a gyakorlatban",
      sections: [
        {
          title: "Az ügyfél perspektívája",
          description: "Az ügyfeled megnyitja a weboldaladat, kiválasztja a szolgáltatást, az időpontot, online fizet, és kap egy automatikus visszaigazolást. Nem kell telefonálnia, nem kell emaileznie — minden automatikus.",
          visual: "client",
        },
        {
          title: "A te perspektívád",
          description: "Látod a bejövő foglalásokat a naptáradban, a rendszer emlékeztet a sessionökre, kezeli a bérleteket és a fizetéseket. Ha egy ügyfél lemondja, a várólistás automatikusan kap értesítést.",
          visual: "coach",
        },
        {
          title: "Automatizált kommunikáció",
          description: "A rendszer küld visszaigazolást, emlékeztetőt 24 és 1 órával előtte, és utólagos follow-up emailt is. Mindez automatikusan, a te nevedben.",
          visual: "automation",
        },
      ],
    },
    useCases: {
      title: "Foglalási forgatókönyvek",
      items: [
        {
          title: "Egyéni coaching program",
          description: "10 alkalmas bérlet egyéni coaching sessionökre, heti rendszerességgel, automatikus emlékeztetőkkel és előrehaladás-követéssel.",
        },
        {
          title: "Csoportos workshop sorozat",
          description: "4 részes workshop sorozat 12 fős létszámkorláttal, automatikus regisztrációval és várólistával.",
        },
        {
          title: "Bemutatkozó session",
          description: "Ingyenes 30 perces ismerkedő beszélgetés, ami után az ügyfél egyből foglalhat fizetős sessiont.",
        },
      ],
    },
    stats: [
      { value: "85%", label: "Adminisztráció megtakarítás" },
      { value: "0", label: "Dupla foglalás" },
      { value: "95%", label: "Megjelenési arány emlékeztetőkkel" },
      { value: "24/7", label: "Foglalás bármikor elérhető" },
    ],
    faq: {
      title: "Foglalási Rendszer — Gyakori Kérdések",
      items: [
        { question: "Az ügyfeleim tudnak online fizetni?", answer: "Igen! Bankkártyás fizetés integrálva van. Az ügyfél a foglaláskor fizet, te pedig automatikus számlát kapsz." },
        { question: "Mi van, ha az ügyfél lemondja a foglalást?", answer: "Beállíthatod a visszamondási feltételeket (pl. 24 órával előtte ingyenes). A rendszer automatikusan kezeli a visszatérítést." },
        { question: "Szinkronizálódik a naptárammal?", answer: "Igen, Google Calendar és Outlook szinkronnal. A foglalások automatikusan megjelennek a naptáradban." },
        { question: "Lehet csoportos foglalást csinálni?", answer: "Igen! Csoportos workshopokat hozhatsz létre létszámkorláttal, automatikus regisztrációval és várólistával." },
        { question: "Hogyan működnek a bérletek?", answer: "Létrehozol egy bérlettípust (pl. 10 alkalom), az ügyfél megvásárolja, és utána az alkalmakat a bérletéből foglalja le. A rendszer automatikusan követi a felhasznált alkalmakat." },
        { question: "Lehet online és személyes sessionöket is kezelni?", answer: "Igen! Mindkét típust kezeli a rendszer. Online sessionökhöz automatikusan generál Zoom/Google Meet linket." },
      ],
    },
    cta: {
      title: "Automatizáld a foglalásaidat",
      subtitle: "Kérj ingyenes visszahívást és megmutatjuk, hogyan takarítasz meg heti 5+ órát adminisztrációval.",
      button: "Ingyenes visszahívást kérek",
    },
  },
  marketingPage: {
    seo: {
      title: "AI Marketing Coachoknak — CoachWorld powered by Bespire",
      description: "AI marketing eszközök coachoknak: social media posztok, blog cikkek, newsletter, SEO — automatikusan, a te hangodban.",
    },
    hero: {
      title: "Marketing, ami nem veszi el az idődet",
      subtitle: "Az AI ismeri a coaching területed, a hangnemed és a célközönséged. Generál posztokat, cikkeket, newsletter-eket — neked csak jóvá kell hagyni.",
      cta: "Ingyenes visszahívást kérek",
    },
    features: {
      title: "AI marketing eszközök coachoknak",
      subtitle: "Részletesen bemutatjuk a legfontosabb marketing funkciókat",
      highlights: [
        {
          title: "Social media, ami magától íródik",
          description: "Az AI generálja a LinkedIn, Instagram és Facebook posztjaidat coaching témákban. Ismeri a szakterületed, a hangnemed, és releváns hashtageket javasol. Egy kattintással publikálhatsz.",
          icon: "Share2",
          points: [
            "LinkedIn, Instagram, Facebook posztok",
            "A te hangodban, a te témáidban",
            "Releváns hashtagek automatikusan",
            "Tartalomnaptár és ütemezett publikálás",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "Newsletter, ami ügyfeleket hoz",
          description: "Automatikus e-mail sorozatok új érdeklődőknek, havi newsletter a meglévő klienseknek. Az AI megírja a tartalmat, te csak jóváhagyod és küldöd.",
          icon: "Mail",
          points: [
            "Automatikus welcome e-mail sorozat",
            "Havi newsletter generálás",
            "Szegmentált küldés célcsoportonként",
            "Megnyitási és kattintási statisztikák",
          ],
          mockupLines: ["", "", "", "", ""],
        },
        {
          title: "Digitális termékek értékesítése",
          description: "Készíts és értékesíts online coaching kurzusokat, e-könyveket, workbookokat. Automatikus hozzáférés a fizetés után, integrált számlázás — passzív bevétel a coaching tudásodból.",
          icon: "BookOpen",
          points: [
            "Online kurzusok videóval és feladatokkal",
            "E-könyvek és workbook értékesítés",
            "Automatikus hozzáférés fizetés után",
            "Kuponkódok és szezonális akciók",
          ],
          mockupLines: ["", "", "", "", ""],
        },
      ],
      items: [
        { title: "Social media posztok", description: "LinkedIn, Instagram, Facebook poszt generálás coaching témákban.", icon: "Share2" },
        { title: "Blog cikkek", description: "SEO-optimalizált szakmai cikkek, amik pozícionálnak.", icon: "BookOpen" },
        { title: "E-mail marketing", description: "Newsletter sorozat, automatikus follow-up emailek.", icon: "Mail" },
        { title: "SEO optimalizálás", description: "Automatikus kulcsszó elemzés és javaslatok.", icon: "Search" },
        { title: "Tartalomnaptár", description: "Heti/havi tartalomnaptár, ütemezett publikálás.", icon: "Calendar" },
        { title: "Online kurzusok", description: "Készíts és értékesíts online coaching kurzusokat.", icon: "Video" },
        { title: "E-könyvek", description: "Publikálj coaching e-könyveket, workbookokat.", icon: "BookOpen" },
        { title: "Kuponok és akciók", description: "Promóciós kódok, szezonális akciók létrehozása.", icon: "Tag" },
        { title: "Analitika", description: "Részletes statisztikák: melyik tartalom hozza a legtöbb ügyfelet.", icon: "BarChart" },
      ],
    },
    deepDive: {
      title: "Így működik az AI marketing a gyakorlatban",
      sections: [
        {
          title: "Tartalom generálás pillanatok alatt",
          description: "Mondd el az AI-nak, miről szeretnél posztolni, és percek alatt elkészül a teljes tartalom — a te hangodban, releváns hashtagekkel, optimalizált formátumban. LinkedIn-re, Instagram-ra és Facebook-ra is egyszerre.",
          visual: "content",
        },
        {
          title: "Automatikus ütemezés és publikálás",
          description: "A tartalomnaptár segítségével hetekre előre ütemezed a posztjaidat. Az AI javaslatot tesz az optimális időpontokra és a legjobb platformokra. Egy kattintással publikálhatsz mindenhova.",
          visual: "schedule",
        },
        {
          title: "E-mail marketing, ami konvertál",
          description: "Új érdeklődőknek automatikus welcome sorozatot küldhetsz. A meglévő klienseknek havi newsletter-t generál az AI a legújabb cikkeidből, sikersztorikból és ajánlataidból.",
          visual: "email",
        },
      ],
    },
    useCases: {
      title: "Marketing forgatókönyvek coachoknak",
      items: [
        {
          title: "Heti tartalomgyártás",
          description: "3 social media poszt, 1 blog cikk, 1 newsletter — mind AI-generálva, a te hangodban, 30 perc alatt az egész hétre.",
        },
        {
          title: "Online kurzus launch",
          description: "Teljes launch kampány: teaser posztok, landing oldal, email sorozat, kuponkódok — az AI megtervezi és elkészíti az egészet.",
        },
        {
          title: "Ügyfélszerzési funnel",
          description: "Lead magnet (ingyenes e-könyv) → email sorozat → bemutatkozó session foglalás → fizetős coaching program. Minden lépés automatizálva.",
        },
      ],
    },
    stats: [
      { value: "10 perc", label: "Heti tartalomgenerálás" },
      { value: "5x", label: "Több online láthatóság" },
      { value: "347", label: "Átlagos feliratkozószám" },
      { value: "40%", label: "Magasabb konverzió" },
    ],
    faq: {
      title: "AI Marketing — Gyakori Kérdések",
      items: [
        { question: "Az AI tényleg jó posztokat ír?", answer: "Igen! Az AI megismeri a coaching területedet és a hangnemed. A generált tartalom professzionális, hiteles és személyre szabott." },
        { question: "Hogyan működik a tartalomnaptár?", answer: "Állítsd be, heti/havi hány posztot szeretnél és milyen platformokra. Az AI generálja a tartalmat, te jóváhagyod, és automatikusan publikálódik." },
        { question: "Online kurzust is értékesíthetek?", answer: "Igen! Készíthetsz videós, szöveges és feladatokat tartalmazó kurzusokat. A kliensek fizetés után automatikusan kapnak hozzáférést." },
        { question: "Mennyibe kerül a marketing funkció?", answer: "Minden marketing eszköz benne van a CoachWorld csomagban. Alap csomag: alap AI használat, Pro csomag: AI-asszisztens a napi munkádhoz." },
        { question: "Lehet automatikus email sorozatot beállítani?", answer: "Igen! Welcome sorozat új érdeklődőknek, havi newsletter, és utólagos follow-up emailek — mind automatikusan küldhetők." },
        { question: "Milyen platformokat támogat?", answer: "LinkedIn, Instagram, Facebook posztok, email marketing, blog cikkek. Minden platformra optimalizált tartalmat generál az AI." },
      ],
    },
    cta: {
      title: "Kezdj el marketingezni AI-al",
      subtitle: "Kérj ingyenes visszahívást és megmutatjuk, hogyan generálod az első heti tartalmadat 10 perc alatt.",
      button: "Ingyenes visszahívást kérek",
    },
  },
  loading: "Betöltés...",
};
